import { ReactElement } from "react";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { colors } from "../../../ui/color";
import { ArrivalIcon } from "../../../ui/icons/arrivalsIcon";
import { DeparturesIcon } from "../../../ui/icons/departuresIcon";
import { HorizontalSecondaryTab } from "../../../ui/organisms/horizontalSecondaryTab";
import { Tab } from "../../../ui/organisms/tab";
import { setSelectedTabNotam } from "../slice";
import { ArrivalNotam } from "./arrivalNotam";
import { DepartureNotam } from "./departureNotam";

export function WarningsAndAlerts() {
    const reportState = useAppSelector(state => state.report);
    const dispatch = useAppDispatch()

    const viewAirportNotamMap = new Map<number, ReactElement>([
        [0, <DepartureNotam />],
        [1, <ArrivalNotam />],
    ])

    return (
        <>
            <HorizontalSecondaryTab>
                <Tab
                    label={"Departure Airport"}
                    selectedSecondary={reportState.selectedTabNotam === 0}
                    onClick={() => dispatch(setSelectedTabNotam(0))}
                    type="secondary"
                    icon={<DeparturesIcon size={20} color={colors.neutral[700]} />}
                />
                <Tab
                    label={"Arrival Airport"}
                    selectedSecondary={reportState.selectedTabNotam === 1}
                    onClick={() => dispatch(setSelectedTabNotam(1))}
                    type="secondary"
                    icon={<ArrivalIcon size={20} color={colors.neutral[700]} />}

                />
            </HorizontalSecondaryTab>
            {viewAirportNotamMap.get(reportState.selectedTabNotam)}
        </>
    );
}
